import * as Yup from 'yup';
import { tankTypes, tankStatuses } from '../constants';

const base = {
  name: Yup.string().required('The tank name is required'),
  volume: Yup.number().required('The tank volume is required'),
  type: Yup.string()
    .oneOf(tankTypes, 'The tank type is not valid')
    .required('The tank type is required')
};

export const tankValidationSchema = Yup.object().shape(base);

export const tankUpdateValidationSchema = Yup.object().shape({
  ...base,
  status: Yup.string()
    .oneOf(tankStatuses, 'The tank status is not valid')
    .required('The tank status is required')
});



// WEBPACK FOOTER //
// ./src/validation/tank.js